﻿import { Question, QuestionnaireValues, SyncableValue } from "../api/models";
import memoize from "lodash.memoize";

const evaluateExpression = (expression: string, questionnaireValues: QuestionnaireValues): boolean => {
    const stateKeyPattern = /\w+\[(\w+|\*)\]/g;
    const evaluatedExpression = expression.replace(stateKeyPattern, match => {
        const key = match.slice(0, match.indexOf("["));
        const expressionValue = match.slice(match.indexOf("[") + 1, match.indexOf("]"));
        const isWildcard: boolean = expressionValue === "*";
        const savedValue = questionnaireValues[key]?.value;
        const isArray: boolean = Array.isArray(savedValue);
        const hasValue: boolean = isWildcard
            ? savedValue?.length > 0
            : isArray
                ? savedValue.includes(expressionValue)
                : savedValue === expressionValue;

        return `${hasValue}`;
    });

    return eval(evaluatedExpression);
};

export function showQuestion(question: Question, questionnaireValues: QuestionnaireValues) {
    if (question.showIf && question.showIf.length > 0) {
        return evaluateExpression(question.showIf, questionnaireValues);
    } else {
        return true;
    }
}

export function getSectionStatus(sectionQuestions: Question[], questionnaireValues: QuestionnaireValues) {
    return {
        complete: sectionQuestions.every(question => {
            const shown = showQuestion(question, questionnaireValues);
            if (!shown) return true;
            if (question.optional) return true; // NEW: optional questions do not require a value
            const value = questionnaireValues[question.id]?.value;
            const isModified = questionnaireValues[question.id]?.isModified;
            const isSaved = questionnaireValues[question.id]?.isSaved;
            return value && value.length > 0 && (!isModified || isSaved);
        }),
    };
}

export function showCheckmark(value: SyncableValue) {
    return value?.isModified && value?.value && value?.isSaved;
}

export function showXmark(value: SyncableValue) {
    return value?.errorMessage || (value?.isModified && !value?.isSyncing && (!value?.value || !value.value.length));
}

function getYearsArray(minDate?: string, disableFuture?: boolean) {
    const latestYear = disableFuture ? new Date().getFullYear() : new Date().getFullYear() + 50;
    const earliestYear = minDate ? new Date(minDate).getFullYear() : latestYear - 50;
    return Array.from({ length: latestYear - earliestYear }, (_, i) => latestYear - i);
}
export const getYears = memoize(getYearsArray);